<div>Assign Attributes</div>
    
<div class="container" cdkDropListGroup>

    <div>
        <div class="assigned-attributes-header">Unassigned</div>
        <div class="assigned-attributes-content">
            <ul class="assigned-attributes-list" cdkDropList [cdkDropListData]="unassignedAttributes" (cdkDropListDropped)="dropAttribute($event)">
                <li cdkDrag *ngFor="let attribute of unassignedAttributes" (click)="onSelect(attribute)" 
                    [ngClass]="attribute === selectedAttribute ? 'selected' : 'not-selected'">
                        {{ attribute.name }}
                </li>
            </ul>
        </div>
    </div>

    <div>
        <div class="assigned-attributes-header">Assigned</div>
        <div class="assigned-attributes-content">
            <ul class="assigned-attributes-list" cdkDropList [cdkDropListData]="assignedAttributes" (cdkDropListDropped)="dropAttribute($event)">
                <li cdkDrag *ngFor="let attribute of assignedAttributes" (click)="onSelect(attribute)" 
                    [ngClass]="attribute === selectedAttribute ? 'selected' : 'not-selected'">
                        {{ attribute.name }}
                </li>
            </ul>
        </div>
    </div>

</div>
    
<div  style="margin-top: 30px;" class="flex-center-center">
    <button
        class="button-color"
        mat-raised-button
        matTooltip="Cancel Edit Consumer Attributes"
        style="margin-right: 60px;"
        type="button"
        (click)="onCancel()"
    >Cancel</button>
    <button
        class="button-color"
        [disabled]="!changesMade()"
        mat-raised-button
        matTooltip="Apply Consumer Attributes"
        type="button"
        (click)="onSubmit()"
    >Apply</button>
</div>

